export default "<div class=\"filter-group\">\n  <ng-content></ng-content>\n</div>\n"